module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Bold.5f19563d.woff";